<template>
<div>
  <div :class="['checkbox-list-item-wrapper', { 'screen-lg': onTabletUp }]">
    <div class="fade-out top" v-if="this.showGradientBorders">&nbsp;</div>
    <div :class="['checkbox-list-item', { 'screen-lg': onTabletUp }]" @click="selectAllItems(allOpt)" v-if="this.showSelectAll && this.allOpt">
      <div class="item-name">
        {{ this.allOpt.name }}
        <span class="item-subtitle" v-if="this.allOpt.subtitle">{{ this.allOpt.subtitle }}</span>
      </div>
      <div :class="['item-icon', { checked: this.allOpt.isSelected }]">
        <svg class="icon-circle" svg-inline="" v-if="!this.allOpt.isSelected" focusable="false" role="presentation" width="26" height="26" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg"><circle cx="28" cy="31" r="12" fill="none" transform="translate(-15 -18)" stroke="#F7C11C" stroke-width="2"/></svg>
        <svg class="icon-circle" svg-inline="" v-if="this.allOpt.isSelected" focusable="false" role="presentation" width="30" height="26" viewBox="0 0 30 26" xmlns="http://www.w3.org/2000/svg"><g transform="translate(1 1)" fill="none" fill-rule="evenodd"><circle stroke="#F7C11C" stroke-width="2" cx="12" cy="12" r="12"/><path d="M20 9l4-4" stroke="#FFF" stroke-width="7" fill="#D8D8D8" stroke-linecap="square"/><path stroke="#F7C11C" stroke-width="2.5" d="M6.884 10l6.094 5.339L25.196 3.737"/></g></svg>
      </div>
    </div>

    <span v-for="(item, i) in items" :key="i">
      <div :class="['checkbox-list-item', { 'screen-lg': onTabletUp }]" @click="selectItem(item)">
        <div class="item-name">
          {{ item.name }}
          <span class="item-subtitle" v-if="item.subtitle">{{ item.subtitle }}</span>
        </div>
        <div :class="['item-icon', { checked: item.isSelected }]">
          <svg class="icon-circle" svg-inline="" v-if="!item.isSelected" focusable="false" role="presentation" width="26" height="26" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg"><circle cx="28" cy="31" r="12" fill="none" transform="translate(-15 -18)" stroke="#F7C11C" stroke-width="2"/></svg>
          <svg class="icon-circle" svg-inline="" v-if="item.isSelected" focusable="false" role="presentation" width="30" height="26" viewBox="0 0 30 26" xmlns="http://www.w3.org/2000/svg"><g transform="translate(1 1)" fill="none" fill-rule="evenodd"><circle stroke="#F7C11C" stroke-width="2" cx="12" cy="12" r="12"/><path d="M20 9l4-4" stroke="#FFF" stroke-width="7" fill="#D8D8D8" stroke-linecap="square"/><path stroke="#F7C11C" stroke-width="2.5" d="M6.884 10l6.094 5.339L25.196 3.737"/></g></svg>
        </div>
      </div>
    </span>
    <div class="fade-out bottom" v-if="this.showGradientBorders">&nbsp;</div>
  </div>
</div>
</template>

<script>
export default {
  name: 'checkbox-list-item',
  components: {},
  props: {
    allOpt: {
      type: Object,
    },
    allowToggleAll: {
      type: Boolean,
      required: true,
    },
    isEmbed: {
      type: Boolean,
    },
    items: {
      type: Array,
      required: true,
    },
    showSelectAll: {
      type: Boolean,
    },
    showGradientBorders: {
      type: Boolean,
      default: false,
    },
    selectMultiple: {
      type: Boolean,
      default: true,
    },
    onTabletUp: {
      type: Boolean,
    },
    validateSelect: {
      type: Boolean,
    },
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {
    validate(item) {
      const hasSelection = this.items.some((item) => item.isSelected === true) || item.isSelected ? true : false;
      this.$emit('is-valid', hasSelection);
    },
    async selectItem(item) {
      if (this.allOpt && this.allOpt.isSelected) {
        this.allOpt.isSelected = false;
      }

      await this.toggleCheck(item);

      if (this.validateSelect) {
        this.validate(item);
      }
    },
    async selectAllItems(item) {
      await this.toggleCheck(item);

      if (this.allowToggleAll) {
        if (item.isSelected) {
          await this.items.forEach((item) => (item.isSelected = true));
        } else {
          await this.items.forEach((item) => (item.isSelected = false));
        }
      } else {
        await this.items.forEach((item) => (item.isSelected = false));
      }

      if (this.validateSelect) {
        this.validate(item);
      }
    },
    async toggleCheck(item) {
      if (!this.selectMultiple) {
        await this.items.forEach((item) => (item.isSelected = false));
      }
      item.isSelected = !item.isSelected;
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'theme.scss';

.fade-out {
  display: block;
  height: 6rem;
  left: 0;
  position: absolute;
  width: 100%;
  z-index: 1;

  &.top {
    background: linear-gradient(180deg, $color-action 0%, rgba($color-action, 0) 100%);
    top: 14.3rem;
  }

  &.bottom {
    background: linear-gradient(180deg, rgba($color-action, 0) 0%, $color-action 60%);
    bottom: 10rem;

    // iPhone 6 up
    @include media('md', null) {
      bottom: 10rem;
    }
  }
}

.checkbox-list-item-wrapper {
  margin-bottom: 1rem;
}

.checkbox-list-item {
  align-items: center;
  background-color: $color-grocery-list-item-bg;
  border: 1px solid $color-grocery-list-border;
  border-radius: $base-border-radius;
  display: flex;
  height: 7rem;
  margin-bottom: 0.5rem;
  padding: 1.25rem 2rem;
  transition: 0.2s;
  will-change: transform;

  &:hover,
  &:active {
    box-shadow: $color-grocery-list-item-shadow;
    cursor: pointer;
  }

  .screen-lg {
    &:active {
      box-shadow: none;
    }
  }

  .item-icon {
    svg {
      circle,
      g path:last-child {
        stroke: $color-checkbox-stroke;
      }
    }

    img.icon-circle {
      left: 1.6rem;
      position: absolute;
      top: 1.8rem;
    }
  }

  .item-name {
    color: $color-grocery-list-item-text;
    flex: 1;
    font-size: 1.6rem;
    font-weight: 600;
    line-height: 1;
    text-align: left;
    text-transform: capitalize;

    .item-subtitle {
      color: $color-lightGrey;
      display: block;
      font-weight: 400;
      margin-top: 0.3rem;
    }
  }
}
</style>
